import React from 'react';
import BrowserFrame from './BrowserFrame';

const EgovPortal: React.FC = () => {
  const services = [
    { label: 'Passeport', icon: '📘', status: 'En cours', color: 'var(--gold-dark)' },
    { label: 'État civil', icon: '👤', status: 'Approuvé', color: '#2E7D32' },
    { label: 'Impôts', icon: '💶', status: 'À traiter', color: 'var(--blue)' },
    { label: 'Santé', icon: '⚕', status: 'Disponible', color: '#5E35B1' },
  ];

  return (
    <BrowserFrame url="gov.mr/services">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        {/* Official header */}
        <div style={{
          padding: '.5rem .7rem', background: 'var(--white)',
          border: '1px solid var(--border)', borderRadius: '3px',
          marginBottom: '.7rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
            <div style={{
              width: '18px', height: '18px',
              background: 'linear-gradient(135deg, var(--blue), var(--gold))',
              borderRadius: '50%',
            }} />
            <div>
              <div style={{ fontSize: '.42rem', color: 'var(--ink2)', letterSpacing: '.12em', textTransform: 'uppercase', fontWeight: 600 }}>République</div>
              <div style={{ fontSize: '.62rem', fontWeight: 700, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif" }}>Services aux Citoyens</div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '3px' }}>
            <div style={{ padding: '.15rem .4rem', background: 'var(--blue)', color: 'white', fontSize: '.45rem', fontWeight: 700, borderRadius: '2px' }}>FR</div>
            <div style={{ padding: '.15rem .4rem', background: 'var(--border)', color: 'var(--ink2)', fontSize: '.45rem', fontWeight: 700, borderRadius: '2px' }}>AR</div>
          </div>
        </div>

        {/* Welcome */}
        <div style={{ marginBottom: '.7rem' }}>
          <div style={{ fontSize: '.5rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase', fontWeight: 600, marginBottom: '.2rem' }}>Bonjour Mohamed S.</div>
          <div style={{ fontSize: '.75rem', fontWeight: 600, color: 'var(--ink)', fontFamily: "'Cormorant Garamond', serif" }}>Que souhaitez-vous faire aujourd'hui ?</div>
        </div>

        {/* Services grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '.4rem', marginBottom: '.7rem' }}>
          {services.map((s) => (
            <div key={s.label} style={{
              background: 'var(--white)', border: '1px solid var(--border)',
              borderRadius: '3px', padding: '.5rem .4rem', textAlign: 'center',
            }}>
              <div style={{ fontSize: '.9rem', marginBottom: '.2rem' }}>{s.icon}</div>
              <div style={{ fontSize: '.5rem', fontWeight: 600, color: 'var(--ink)', marginBottom: '.15rem' }}>{s.label}</div>
              <div style={{ fontSize: '.42rem', color: s.color, fontWeight: 600 }}>● {s.status}</div>
            </div>
          ))}
        </div>

        {/* Demarches */}
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '3px', padding: '.55rem .65rem' }}>
          <div style={{ fontSize: '.45rem', color: 'var(--ink2)', letterSpacing: '.1em', textTransform: 'uppercase', fontWeight: 600, marginBottom: '.35rem' }}>Mes démarches en cours</div>
          {[
            { label: 'Renouvellement passeport', date: '12/04', status: 'Validé', color: '#2E7D32' },
            { label: 'Déclaration impôts 2025', date: '05/04', status: 'En attente', color: 'var(--gold-dark)' },
          ].map((d, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '.25rem 0',
              borderTop: i > 0 ? '1px solid var(--border)' : 'none',
              fontSize: '.5rem',
            }}>
              <span style={{ color: 'var(--ink)' }}>{d.label}</span>
              <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
                <span style={{ color: 'var(--ink2)', fontSize: '.42rem' }}>{d.date}</span>
                <span style={{ color: d.color, fontWeight: 700, fontSize: '.45rem' }}>● {d.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </BrowserFrame>
  );
};

export default EgovPortal;
